import { createAction } from 'redux-actions';
import { createRequestAction } from 'utils/action';

// 获取练习列表

export const getExerciseList = createAction('GET_EXERCISE_LIST');
export const realGetExerciseList = createRequestAction('REAL_GET_EXERCISE_LIST');

// 获取做题记录
export const getRecord = createAction('GET_RECORD');
export const realGetRecord = createRequestAction('REAL_GET_RECORD');

// 设置做题记录
export const setRecord = createAction('SET_RECORD');
export const realSetRecord = createAction('REAL_SET_RECORD');

// 设置做题时间
export const setTimer = createAction('SET_TIMER');
export const realSetTimer = createAction('REAL_SET_TIMER');

// 上传答案
export const postAnswer = createAction('POST_ANSWER');
export const realPostAnswer = createRequestAction('REAL_POST_ANSWER');

// 获取上传签名
export const getUploadSignature = createAction('GET_UPLOAD_SIGNATURE');
export const realGetUploadSignature = createRequestAction('REAL_GET_UPLOAD_SIGNATURE');

// 上传纠错图片
export const postCorrectionImage = createAction('POST_CORRECTION_IMAGE');
export const realPostCorrectionImage = createRequestAction('REAL_POST_CORRECTION_IMAGE');

// 上传纠错
export const postCorrection = createAction('POST_CORRECTION');
export const realPostCorrection = createRequestAction('REAL_POST_CORRECTION');

// 机器批改
export const postMachinePigai = createAction('POST_MACHINE_PIGAI');
export const realPostMachinePigai = createRequestAction('REAL_POST_MACHINE_PIGAI');

// 保存时间
export const postDuration = createAction('POST_DURATION');
export const realPostDuration = createRequestAction('REAL_POST_DURATION');

// 开始精听练习
export const postListen = createAction('POST_LISTEN');
export const realPostListen = createRequestAction('REAL_POST_LISTEN');

// 结束精听练习
export const postListenComplete = createAction('POST_LISTEN_COMPLETE');
export const realPostListenComplete = createRequestAction('REAL_POST_LISTEN_COMPLETE');

// 重置精听练习
export const postListenReset = createAction('POST_LISTEN_RESET');
export const realPostListenReset = createRequestAction('REAL_POST_LISTEN_RESET');

// 开始跟读练习
export const postRepeat = createAction('POST_REPEAT');
export const realPostRepeat = createRequestAction('REAL_POST_REPEAT');

// 获取跟读进度
export const getRepeatDetail = createAction('GET_REPEAT_DETAIL');
export const realGetRepeatDetail = createRequestAction('REAL_GET_REPEAT_DETAIL');

// 更新跟读进度
export const postRepeatAnswer = createAction('POST_REPEAT_DETAIL');
export const realPostRepeatAnswer = createRequestAction('REAL_POST_REPEAT_DETAIL');

// 结束跟读练习
export const postRepeatComplete = createAction('POST_REPEAT_COMPLETE');
export const realPostRepeatComplete = createRequestAction('REAL_POST_REPEAT_COMPLETE');

// 绑定 exerciseId 和 token 的关系
export const exerciseBelong = createAction('POST_EXERCISE_BELONG');
export const realExerciseBelong = createRequestAction('REAL_POST_EXERCISE_BELONG');



// WEBPACK FOOTER //
// ./src/actions/record.js